import {
    GET_FILTERS_DATA,
    GET_FILTERS_DATA_SUCCESS,
    GET_FILTERS_DATA_FAIL,
    SET_FILTERS_DATA,
    SET_FILTERS_DATA_SUCCESS,
    SET_FILTERS_DATA_FAIL
} from "./actionTypes";

export const getFiltersData = () => ({
    type: GET_FILTERS_DATA,
});

export const getFiltersDataSuccess = (data) => ({
    type: GET_FILTERS_DATA_SUCCESS,
    payload: data,
} );

export const getFiltersDataFail = (error) => ({
    type: GET_FILTERS_DATA_FAIL,
    payload: error,
}  );

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    payload: data,
} );

export const setFiltersDataSuccess = (data) => ({
    type: SET_FILTERS_DATA_SUCCESS,
    payload: data,
} );

export const setFiltersDataFail = (error) => ({
    type: SET_FILTERS_DATA_FAIL,
    payload: error,
} );